import * as React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import Divider from '@mui/joy/Divider';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import Typography from '@mui/joy/Typography';
import Check from '@mui/icons-material/Check';

import { Stack } from '@mui/joy';


const PackagePlansCard = () => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 300px), 1fr))',

            }}
        >
            <Card size="lg" variant="outlined">
                <Typography level="h3" sx={{ textAlign: 'center' }}> Standard Plan</Typography>
                <Typography level="h3" sx={{ textAlign: 'center' }}> € 10.99</Typography>
                <Typography level='body-xs' sx={{ textAlign: 'center' }}>  Incl all taxes </Typography>
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'left' }}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <ListItemDecorator>
                        <Check />
                    </ListItemDecorator>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>

                <CardActions>

                    <Button
                        sx={{
                            padding: "6px", maxWidth: "150px", textAlign: "center", margin: 'auto',
                            backgroundColor: "#28A745",
                            "&:hover": {
                                backgroundColor: "#28A745",
                                color: "#ffffff", boxShadow: 3,
                            },

                        }}>Buy Now</Button>
                </CardActions>
            </Card>

        </Box>
    );
}

export default PackagePlansCard;


